import './ParallaxBreak.css';

const ParallaxBreak = () => {
  return (
    <section className="parallax-break">
      <div className="parallax-image-wrapper">
        <img
          src="/assets/parallax-werf.jpg"
          alt="Vakmensen aan het werk"
          className="parallax-image"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80';
          }}
        />
        <div className="parallax-overlay" />
      </div>

      <div className="parallax-content">
        <span className="parallax-label">Kwaliteit &amp; vakmanschap</span>
        <h2 className="parallax-title">
          Personeel dat de werf al kent, niet moet leren kennen
        </h2>
        <p className="parallax-text">
          Onze vakmensen werken VCA-gecertificeerd en zijn direct inzetbaar op
          scheepswerven en industriële locaties.
        </p>
      </div>
    </section>
  );
};

export default ParallaxBreak;
